import { render } from "./TestOurService.vue?vue&type=template&id=5a35a267&scoped=true&ts=true"
import script from "./TestOurService.vue?vue&type=script&lang=ts"
export * from "./TestOurService.vue?vue&type=script&lang=ts"

import "./TestOurService.vue?vue&type=style&index=0&id=5a35a267&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a35a267"]])

export default __exports__